import { COLORS, SIZES } from "@app/constants";
import styled from "styled-components";

export const HighestProfitSection = styled.div`
  font-size: ${SIZES.h4};
  font-family: "Spoqa Han Sans Neo", "sans-serif";
  margin-block: 30px;
  width: 100%;
`;
export const HighestProfitListSection = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  width: 100%;

  @media (max-width: 1400px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;
export const ProfitItemSection = styled.div`
  width: 100%;
  height: 380px;
  border-radius: 8px;
  border: 0.5px solid ${(p) => p.theme.COLORS.borderColor};
  position: relative;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: ${(p) => p.theme.COLORS.bgColor};
  box-shadow: 0 4px 24px rgb(0 0 0 / 5%);
  overflow: hidden;

  &:hover {
    box-shadow: 2px 3px 20px ${COLORS.primaryDark};
    transform: translateY(-2px);
  }
`;
